import { useTranslation } from 'react-i18next';
import { Divider, Stack, Typography } from '@mui/material';
import { CreditCardOff } from '@mui/icons-material';
import { useDrawingArea, useXScale } from '@mui/x-charts-pro';
import { timeDurationShort } from '@/utilities/timeUtils';

export function TachographNoDataIcon({ noCardEvents }: { noCardEvents: { from: number; to: number }[] }) {
  const { t } = useTranslation();
  const { height } = useDrawingArea();
  const xScale = useXScale();
  const labelHeight = 25;
  const y = height - (height / 4 - labelHeight) / 2;

  return (
    <g pointerEvents="none">
      {noCardEvents.map((empty, i) => {
        const startX = xScale(empty.from);
        const endX = xScale(empty.to);
        if (!startX || !endX) return;

        const width = endX - startX;
        const durationMicro = (empty.to - empty.from) * 3600 * 1_000_000 + 1;

        let content: React.ReactNode;
        if (width <= 50) {
          content = null;
        } else if (width < 150) {
          content = (
            <Stack direction="row" alignItems="center" spacing={1}>
              <CreditCardOff color="disabled" />
            </Stack>
          );
        } else {
          content = (
            <>
              <Stack direction="row" alignItems="center" spacing={1}>
                <CreditCardOff color="disabled" />
                <Typography variant="body2" color="textDisabled">
                  {timeDurationShort(t, durationMicro, undefined, true)}
                </Typography>
              </Stack>
            </>
          );
        }

        return (
          <g key={i + '-' + empty.from + '-' + empty.to}>
            <foreignObject x={startX} y={y} width={width} height={labelHeight}>
              <Divider textAlign="center">{content}</Divider>
            </foreignObject>
          </g>
        );
      })}
    </g>
  );
}
